var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity-tab"},[_c('div',[_c('div',{staticClass:"title active"},[_c('span',[_vm._v(_vm._s(_vm.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }